import Card from "@pathwright/ui/src/components/card/Card"
import {
  FeatureAction,
  FeatureKey,
  FeaturePermission
} from "@pathwright/graphql-client/src/generated"
import FeatureBlockContainer from "../../feature/block/FeatureBlockContainer"
import { Container as FeatureBlockListContainer } from "../../feature/block/FeatureBlockList"
import useUnifiedHomePermissions from "../../unified-home/view-permission/useUnifiedHomePermissions"

const ManageLabFeatures = ({ card }: { card: any }) => {
  const permissions = useUnifiedHomePermissions()
  // Should only show the home screen feature to admin when the feature isn't enabled for the school.
  // This is mainly to prevent newer schools who have had the feature enabled by default from seeing
  // the lab feature option, but this will also mean once a school enables the feature, admins will no longer
  // see the lab feature option as well.
  const shouldSeeHomeScreenFeature =
    permissions.schoolScopedCFP?.permission_in_context !==
    FeaturePermission.Everyone

  return (
    <Card card={card} title="Lab Features">
      <FeatureBlockListContainer>
        {shouldSeeHomeScreenFeature && (
          <FeatureBlockContainer
            featureKey={FeatureKey.HomeScreenUnified}
            featureAction={FeatureAction.HomeScreenView}
            context={null}
            to={`${card.path}home/`}
          />
        )}
        <FeatureBlockContainer
          featureKey={FeatureKey.LibraryCoverPages}
          featureAction={FeatureAction.CoverPagesView}
          context={null}
          to={`${card.path}cover-pages/`}
        />
      </FeatureBlockListContainer>
    </Card>
  )
}

export default ManageLabFeatures
